module.exports = __webpack_public_path__ + "img/placeholder.b7e53da6.png";